import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.sass']
})
export class PasswordResetComponent  {
  processing = false
  title: string = 'AUTH.RESTORE-PASSWORD'
  options: AnimationOptions = {
    path: '/assets/animations/loading.json',
  }

  signInForm = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.email]),
    
  })

  constructor(
    private auth: AuthService,
    private router: Router,
    public utils: UtilsService,
  ) {
  }

  authenticate() {
    this.processing = true
    this.auth.recover(
      {
        email: this.signInForm.controls.username.value,
      }
    )
      .subscribe(
        {
          next: value => this.handleAPISuccess(value),
          error: err => this.handleError(err)
        }
      )
  }

  handleAPISuccess(data: any) {
    this.utils.toast.saved(this.title)
    setTimeout(() => {
      this.router.navigateByUrl(`/auth/sign-in`)
    }, 300);
  }

  awsSignUp(data: any, error: any) {
  }

  handleAmplifySignUpSuccess() {
    this.router.navigateByUrl(`/auth/confirm-account/${this.signInForm.controls.username.value}`)
  }

  handleAmplifySuccess(data: any) {
    this.auth.handleSuccess(data, () => {
      this.processing = false
    })
  }

  handleError(error: any) {
    this.processing = false
    console.error(error)
    this.utils.toast.error(this.title)
    //this.dataError = 1
  }

}

